module.exports = require('./lib');


//////////////////
// WEBPACK FOOTER
// ../~/joi/index.js
// module id = 28
// module chunks = 0